var map = {
	"./abc_logo.png": "8ab4",
	"./aia_logo.png": "f26d",
	"./apeiron-logo.png": "142c",
	"./apex_logo.png": "84b4",
	"./asia-insurance-logo-white.png": "053d",
	"./asia_insurance_logo.png": "f835",
	"./berkley_logo.png": "863a",
	"./bupa_logo.png": "830f",
	"./chubb_logo.png": "3b9a",
	"./companycover-logo-white.png": "a53d",
	"./companycoverlogo-white.png": "38aa",
	"./contractor_all_risk.svg": "73b5",
	"./cyber.svg": "b600",
	"./domestic_helper.svg": "b416",
	"./explosion.svg": "5e23",
	"./fiLife_logo.png": "2bf0",
	"./hkecic_logo.png": "8c10",
	"./home.svg": "e3e6",
	"./insurer_logo.png": "05ab",
	"./keepcovered-logo.jpg": "0177",
	"./login-image.svg": "edd9",
	"./macaucover_logo.png": "b7b1",
	"./medical.svg": "1533",
	"./motor.svg": "107a",
	"./muangthai-logo.png": "ac02",
	"./myvhis-logo-white.png": "a4af",
	"./personal_accident.svg": "86a2",
	"./pet.svg": "06db",
	"./sme.svg": "797e",
	"./term_life.svg": "402b",
	"./travel.svg": "b430"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";